import script from "./sub-nav.vue?vue&type=script&lang=tsx"
export * from "./sub-nav.vue?vue&type=script&lang=tsx"

const __exports__ = script;

export default __exports__